export const globalConstants = {
  sinforToken: '@sinfor_token',
  baseAppName: '/web',
}